import React from 'react'
import { ButtonBase } from './styles'

const SmallButtonSecondary = ({ children, ...props }) => (
  <ButtonBase {...props}>{children}</ButtonBase>
)

export default SmallButtonSecondary
